import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import SettingsUser from './SettingsUser';
import SettingsDocUp from './SettingsDocUp';
import SettingsDocUpTrk from './SettingsDocUpTrk';
import SettingsPrompt from './SettingsPrompt';
import SettingsDocUpNew from './SettingsDocUpNew';
import SettingsDocUpTrkNew from './SettingsDocUpTrkNew';
import SettingsKnowledgeFaq from './SettingsKnowledgeFaq';
import SettingsHistoryDownload from './SettingsHistoryDownload';

import { ModeContext } from './ModeContext';
import { Divider, Container, Box, Typography, Card, CardContent } from '@mui/material';

import { Settings } from '@mui/icons-material';


const SettingsMain = () => {
    console.log('MainAdmin:start')
    const {activeAdminComponent, setActiveAdminComponent} = useContext(ModeContext);

    return (
        <div className="chat-container">
        <Typography variant="h6" component="div" sx={{ color: '#1976d2',ml: 2 }}>
            管理者メニュー
        </Typography>
        <Divider sx={{ marginY: 1,marginX: 1, borderColor: '#1976d2' }} />

        {activeAdminComponent === 'AdminUserSetting' && <SettingsUser />}
        {activeAdminComponent === 'AdminDocSetting' && <SettingsDocUp />}
        {activeAdminComponent === 'AdminDocTrkSetting' && <SettingsDocUpTrk />}
        {activeAdminComponent === 'AdminPromptSetting' && <SettingsPrompt />}
        {activeAdminComponent === 'AdminDocNewSetting' && <SettingsDocUpNew />}
        {activeAdminComponent === 'AdminDocTrkNewSetting' && <SettingsDocUpTrkNew />}
        {activeAdminComponent === 'AdminKnowledgeFaqSetting' && <SettingsKnowledgeFaq />}
        {activeAdminComponent === 'AdminHistoryDownload' && <SettingsHistoryDownload />}
      </div>
    );
};

export default SettingsMain;